export default __webpack_public_path__ + "static/media/item1@2x.4800f0e4.png";